import { useLocation } from 'react-router';

import { isMlbPage } from '#src/constants/routes.ts';

export const useIsMlbPage = () => {
  const location = useLocation();

  return isMlbPage(location.pathname);
};
